import displayCodeValidity from "./features/displayCodeValidity";
import validatePromoCode from "./features/validatePromoCode";
import { ui } from "./utils/ui";

export default () => {
  if (!ui.promoInput) return;
  const codeValidity = document.createElement("p");
  codeValidity.classList.add("code-validity");
  ui.formInputCode.appendChild(codeValidity);

  ui.promoInput.addEventListener("focusout", async (e) => {
    const code = ui.promoInput.value.trim();
    if (code !== "") {
      const isValid = await validatePromoCode(code);
      displayCodeValidity(isValid, codeValidity);
    } else {
      codeValidity.innerHTML = "";
    }
  });

};

